import { z } from "zod";
import { AbstractExtractSchema } from "./abstract/abstractExtract.entities";
import { HbIdSchema } from "../traits";

export enum ExtractSupplierSchemaEnum {
	ExtractSupplier = "ExtractSupplier"
};

export const ExtractSupplierSchema = AbstractExtractSchema
	.merge(HbIdSchema)
	.merge(z.object({
		"@id": z.string(), // "/api/extract_suppliers/1"
		"@type": z.string(), // "ExtractSupplier"
		id: z.number(), // 1
		actif: z.string(), // "1"
		libelle: z.string(), // "Supplier 1"
	}))
	.describe(ExtractSupplierSchemaEnum.ExtractSupplier);

export type ExtractSupplier = z.infer<typeof ExtractSupplierSchema>;
